let _jwtToken: string | null = null;

export const auth = {
  setToken: (token: string) => {
    _jwtToken = token;
  },
  getToken: () => _jwtToken,
};
